import {dateToString} from "../dateTimeFormat";

class ATableAccess {
    static add = async (db, tableName, data) => {
        if (!db) {
            return false;
        }

        data["counter"] = 1;
        data["dateCreated"] = dateToString(new Date(), "YYYYMMDDHHmmss");
        data["lastUpdated"] = dateToString(new Date(), "YYYYMMDDHHmmss");
        await db.add(tableName, data);

        return true;
    };

    static getById = async (db, tableName, id) => {
        if (!db) return null;
        if (!tableName) return null;
        if (!id) return null;
        try {
            return await db
                .transaction(tableName, "readonly")
                .objectStore(tableName)
                .get(id);
        } catch (ex) {
            console.log(ex);
            return null;
        }
    };

    static getByDbId = async (db, tableName, dbId) => {
        if (!db) return null;
        if (!tableName) return null;
        if (!dbId) return null;
        try {
            return await db.getFromIndex(tableName, "dbId", dbId);
        } catch (ex) {
            console.log(ex);
            return null;
        }
    };

    static getByNumber = async (db, tableName, number) => {
        if (!db) return null;
        if (!tableName) return null;
        if (!number) return null;
        try {
            return await db.getFromIndex(tableName, "number", number);
        } catch (ex) {
            console.log(ex);
            return null;
        }
    };

    static getByName = async (db, tableName, name) => {
        if (!db) return null;
        if (!tableName) return null;
        if (!name) return null;
        try {
            return await db.getFromIndex(tableName, "name", name);
        } catch (ex) {
            console.log(ex);
            return null;
        }
    };

    static getAll = async (db, tableName) => {
        if (!db) return [];
        if (!tableName) return [];
        try {
            // const abc = await db
            //     .transaction(tableName, "readonly")
            //     .objectStore(tableName)
            //     .getAll();

            return await db
                .transaction(tableName, "readonly")
                .objectStore(tableName)
                .getAll();
        } catch (ex) {
            console.log(ex);
            return [];
        }
    };

    static updateById = async (db, tableName, id, data) => {
        if (!db) return null;
        if (!tableName) return null;
        if (!id) return null;

        const tx = db.transaction(tableName, "readwrite");
        let objectStore = await tx.objectStore(tableName);

        const savedData = await objectStore.get(id);

        let counter = 1;
        if (savedData["counter"] !== null && savedData["counter"] !== undefined)
            counter = savedData["counter"] + 1;
        if (data["counter"] !== null && data["counter"] !== undefined)
            counter = data["counter"] + 1;

        let newSavedData = {...data};

        newSavedData["id"] = savedData["id"];
        newSavedData["counter"] = counter;
        newSavedData["dateCreated"] = savedData["dateCreated"];
        newSavedData["lastUpdated"] = dateToString(new Date(), "YYYYMMDDHHmmss");

        const updateRequest = await objectStore.put(newSavedData);

        await tx.done;
    };

    static updateCounterToZero = async (db, tableName) => {
        if (!db) return null;
        if (!tableName) return null;

        for (const data of await this.getAll(db, tableName)) {
            const newData = {...data};
            newData["counter"] = -1;
            await this.updateById(db, tableName, data.id, newData);
        }
    };

    static deleteById = async (db, tableName, id) => {
        if (!db) return null;
        if (!tableName) return null;
        if (!id) return null;

        const tx = db.transaction(tableName, "readwrite");
        await tx.objectStore(tableName).delete(id);

        await tx.done;
    };

    static deleteByDbId = async (db, tableName, dbId) => {
        if (!db) return null;
        if (!tableName) return null;
        if (!dbId) return null;

        const tx = db.transaction(tableName, "readwrite");
        let objectStore = await tx.objectStore(tableName);

        const record = await this.getByDbId(db, tableName, dbId)
        if (record)
            await this.deleteById(db, tableName, record.id)

    };

    static deleteAll = async (db, tableName) => {
        if (!db) return null;
        if (!tableName) return null;

        for (const data of await this.getAll(db, tableName)) {
            await this.deleteById(db, tableName, data.id);
        }
    };

    static deleteWhereCounterEqualsZero = async (db, tableName) => {
        if (!db) return null;
        if (!tableName) return null;

        for (const data of await this.getAll(db, tableName)) {
            if (data.counter === 0) await this.deleteById(db, tableName, data.id);
        }
    };

    static getCount = async (db, tableName) => {
        if (!db) return 0;
        if (!tableName) return 0;
        try {

            return await db
                .transaction(tableName, "readonly")
                .objectStore(tableName)
                .count();
        } catch (ex) {
            console.log(ex);
            return 0;
        }
    };

}

export default ATableAccess;
